/**
 * Extracts x-axis category labels from raw dashboard API items.
 * Returns a plain data object — no chart library dependency.
 */
export const chartOptions = (items: any[]): { xaxis: { categories: string[] } } => {
  return {
    xaxis: {
      categories: (items ?? []).map((item) => item?.date ?? ''),
    },
  };
};
